const STORAGE_PREFIX = 'dw-nux-dismissed'

function storageKey(userId: string): string {
  return `${STORAGE_PREFIX}:${userId}`
}

export function readCachedNuxDismissals(userId: string): Set<string> {
  if (typeof window === 'undefined') return new Set()
  try {
    const raw = window.localStorage.getItem(storageKey(userId))
    if (!raw) return new Set()
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return new Set()
    return new Set(parsed.filter((value): value is string => typeof value === 'string'))
  } catch {
    return new Set()
  }
}

export function writeCachedNuxDismissals(userId: string, dismissedIds: Iterable<string>): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(storageKey(userId), JSON.stringify([...new Set(dismissedIds)]))
  } catch {
    // Cache failure must not break onboarding.
  }
}

export function addCachedNuxDismissal(userId: string, tooltipId: string): Set<string> {
  const next = readCachedNuxDismissals(userId)
  next.add(tooltipId)
  writeCachedNuxDismissals(userId, next)
  return next
}
